export default "__VITE_ASSET__nWr62RSU__"